import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Lata Sharma </span>
            from <span className="purple"> Sirmour (Himachal), India.</span>
            <br />Currently I am working with Cyber Labs (Chandigarh).
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
            <span role="img" aria-label="book">📘</span>
            Reading
            </li>
            <li className="about-activity">
            <span role="img" aria-label="Exercise">🏋‍♀</span>
              Exercise and yoga
            </li>
            <li className="about-activity">
            <span role="img" aria-label="Hiking">🧗🏻‍♀️</span>
              Hiking
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer"></footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
